import { effect, inject, Injectable } from '@angular/core';
import { resolveActiveOrder } from '@config/app-steps-order.config';
import { ApplicationMetadataService } from '@services/api-calls/application-metadata.service';
import { ApplicationService } from '@services/api-calls/application.service';
import { StepperService } from '@services/layout/stepper.service';

/**
 * Bridges the loaded application to the stepper's active order. Lives in its own
 * root-provided service because StepperService transitively depends on
 * ApplicationMetadataService, so the metadata service cannot inject the stepper.
 * Must be eagerly injected somewhere (the root App component) for its effect to run —
 * a side-effect-only root service is never constructed otherwise.
 */
@Injectable({
    providedIn: 'root',
})
export class StepsOrderBootstrapService {
    private applicationService = inject(ApplicationService);
    private applicationMetadataService = inject(ApplicationMetadataService);
    private stepperService = inject(StepperService);

    constructor() {
        effect(() => {
            const app = this.applicationService.rawApplication();
            if (!app) return;
            this.stepperService.setStepsOrder(resolveActiveOrder(app));
            this.applicationMetadataService.stampDefaultOrderIfMissing();
        });
    }
}
